let authConfig: {
  getAccessToken?: () => Promise<string | undefined>;
  instanceId?: string;
  companyId?: string;
} = {};

export function configureAuth(config: {
  getAccessToken?: () => Promise<string | undefined>;
  instanceId?: string;
  companyId?: string;
}): void {
  authConfig = config;
}

export function setAuthCompanyId(companyId: string | undefined): void {
  authConfig = { ...authConfig, companyId };
}

export function getAuthConfig(): {
  getAccessToken?: () => Promise<string | undefined>;
  instanceId?: string;
  companyId?: string;
} {
  return authConfig;
}

export async function authFetch(
  input: RequestInfo | URL,
  init?: RequestInit,
): Promise<Response> {
  const headers = new Headers(init?.headers);

  if (authConfig.getAccessToken) {
    try {
      const token = await authConfig.getAccessToken();
      if (token) {
        headers.set("Authorization", `Bearer ${token}`);
      }
    } catch (error) {
      console.error("[authFetch] Error getting access token:", error);
    }
  }

  if (authConfig.instanceId) {
    headers.set("X-Instance-Id", authConfig.instanceId);
  }

  if (authConfig.companyId) {
    headers.set("X-Company-Id", authConfig.companyId);
  }

  return fetch(input, {
    ...init,
    headers,
  });
}
